import MxTooltipBasic from "@rf-l1/tooltip/MxTooltipBasic";
import { IconCloudDownload } from "@tabler/icons-react";
import { IconFileUpload } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";

import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

import { Button, Grid, useTheme } from "@mui/material";
import MxFormDescriptionTitle from "@rf-l1/page/form/MxFormDescriptionTitle";
import useUpTemplateBuilding from "../../hooks/useUpTemplateBuilding/useUpTemplateBuilding";
import useImportBuildingsUnitsModal from "../../hooks/useImportBuildingsUnitsModal";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import patchProjectTemplateAdapter from "@rf/property/module/adapters/form/patch-project-template-adapter";
import useAlert from "@rf-hooks/useAlert";
import { useFormContext } from "react-hook-form";
import { useBuildingsContext } from "../../context/Buildings-contexts/BuildingsContext";
import MxTypography from "@rf-l1/MxTypography";
import MxButton2 from "@rf-l1/buttons/MxButton2";

const HeaderBuilding = () => {
  const theme = useTheme();
  const { alert } = useAlert();
  const { setValue, getValues, trigger } = useFormContext();
  const { getUpBuildingFromTemplate } = useBuildingsContext();
  const { downloadExcelFiles } = useUpTemplateBuilding(
    getValues(CPropertyFormKeys.type_property)
  );
  const { handleOpen: openImportModal } = useImportBuildingsUnitsModal({
    typeProperties: getValues(CPropertyFormKeys.type_property)
  });

  const remplaceBuildingForTemplate = (template: any) => {
    const Buildings = getValues(CPropertyFormKeys.building);
    const { building } = patchProjectTemplateAdapter(template);
    setValue(
      CPropertyFormKeys.buildingsDeleted,
      Buildings.map((building: any) => building.id)
    );
    getUpBuildingFromTemplate(building);
    trigger(CPropertyFormKeys.building);
  };

  const handleTemplate = async () => {
    const Buildings = getValues(CPropertyFormKeys.building);
    const lengthBuildings = Buildings.length;

    const openAndHandle = () =>
      openImportModal().then(res => {
        if (res.type.confirm && res.value) {
          remplaceBuildingForTemplate(res.value);
        }
      });

    if (lengthBuildings > 0) {
      alert({
        title: "Advertencia",
        message:
          "Se remplazará el listado de todas las etapas o bloques actual por la información de la plantilla ¿Desea continuar?",
        type: "warning",
        color: "warning.main",
        confirmBtnMessage: "Si",
        declineBtnMessage: "No"
      }).then(result => {
        if (result.type.confirm) {
          openAndHandle();
        }
      });
    } else {
      openAndHandle();
    }
  };
  return (
    <Grid container item xs={12} rowGap={2} ml={3} mb={2}>
      <Grid item xs={12}>
        <MxFormSubTitle label="Etapa o bloque" />
      </Grid>

      <Grid item xs={12}>
        <MxTypography color="grey.700" variant="overline">
          El formato de archivo permitido para importar etapas y unidades es un xlsx.
          <span
            onClick={downloadExcelFiles}
            style={{
              textDecoration: "underline",
              marginLeft: 5,
              color: theme.palette.primary.light,
              cursor: "pointer"
            }}
          >
            Descargar Plantilla
          </span>
        </MxTypography>
      </Grid>

      <Grid item xs={12}>
        <MxButton2
          onClick={handleTemplate}
          endIcon={<IconFileUpload size={16} />}
          variant="contained"
          sx={{
            background: "#8ebf4c",
            ":hover": {
              background: "#8ebf4c"
            }
          }}
        >
          Importar bloques y unidades
        </MxButton2>
      </Grid>
    </Grid>
  );
};

export default HeaderBuilding;
